import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  moduleId: module.id,
  templateUrl: 'forgot.password.component.html'
})

export class ForgotPasswordComponent implements OnInit {
  loading = false;
  error = '';
  success = '';
  forgotPasswordForm = new FormGroup({
    email: new FormControl('', Validators.compose([
      Validators.required,
      Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    ])),
  });
  submitted = false;

  constructor(private router: Router, private authenticationService: AuthenticationService) {
    //
  }

  onSubmit({value, valid}) {
    this.submitted = true;

    if (valid) {
      this.loading = true;

      this.authenticationService.forgotPassword(value.email).subscribe(result => {
        this.loading = false;
        this.success = 'Instructions to reset password were sent to your email. Please check them.';
      }, (err => {
        console.log(err);
        this.error = 'Email does not exist';
        this.loading = false;
      }));
    }
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot.password.component.ts